<template>
    <Toast />
    <MenuComponent />

    <Dialog modal :closable="false" v-model:visible="modal2">
        <br>
        <p class="tetx-12 text-center">¿Seguro de cerrar? La información se eleiminara y perderas tu progreso</p>
        <br><br>
        <div class="cont-100 d-flex-f">
            <div class="cont-45 mr-auto">
                <Button class="cont-100" label="Cancelar" @click="modal2 = false" severity="secondary"></Button>
            </div>
            <div class="cont-45 mr-auto">
                <Button class="cont-100" label="Confirmar" @click="ElimiarData" severity="contrast"></Button>
            </div>
        </div>
    </Dialog>

    <Dialog class="modal-1" modal :closable="false" v-model:visible="modal">
        <Button icon="pi pi-times" severity="secondary" @click="cerrarModal" />
        <div class=" cont-100 m-auto">
            <div class="contenedor1">
                <div class="contenedor1">
                    <div>
                        <p class="title-1">Registrar nueva empresa</p>
                        <p class="title-2">Rellena todos los campos para continuar</p>
                        <br>
                        <br>
                        <div>
                            <label for="">
                                <i class="pi pi-building blue"></i>
                                Detalle de la compañia
                            </label>
                        </div><br>


                        <br>
                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="rfc" class="cont-100" />
                                        <label for="on_label">RFC</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="nombre_comercial" class="cont-100" />
                                        <label for="on_label">Nombre Comercial</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="nombre_contacto" class="cont-100" />
                                        <label for="on_label">Nombre de contacto</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="correo" class="cont-100" />
                                        <label for="on_label">Correo Electrónico</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>
                        <br>

                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <MultiSelect v-model="empresa" :options="empresas" optionValue="nombre"
                                            optionLabel="nombre" id="empresa_1" filter :maxSelectedLabels="5"
                                            class="cont-100" />
                                        <label for="empresa_1">Empresa que ejecuta</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel class="w-full md:w-56" variant="in">
                                        <Select v-model="tipoCliente" :options="tipo" filter optionLabel="nombre"
                                            class="cont-100 ">
                                        </Select>
                                        <label for="on_label">Selecciona Tipo de cliente</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>
                        <br>
                        <Button class="m-auto d-block cont-100" @click="registrar" label="Registrar" severity="contrast"
                            icon="pi pi-arrow-right" />
                    </div>
                </div>
            </div>
        </div>
    </Dialog>

    <div class="wrap">
        <DataTable v-model:filters="model" :value="prospectos" paginator :rows="7" dataKey="id" filterDisplay="row"
            :globalFilterFields="['Nombre', 'Razon_Social']">

            <template #header>
                <div class="flex justify-between align-items-center">
                    <Button icon="pi pi-plus" label="Agregar Prospecto" class="p-button-success mr-l-2"
                        @click="abrirRegistro" />
                </div>
            </template>

            <!-- <Column header="Acciones" style="min-width: 10rem">
                <template #body="{ data }">
                    <button v-tooltip.bottom="{
                        value: 'Ver Organizacion',
                        showDelay: 500,
                        hideDelay: 300,
                    }" class="button bg-hov-primary text-hov-white border-rad-2 mr-auto" style="width: 40px;"
                        @click="OpenEdit(data)">
                        <i class="pi pi-eye"></i>
                    </button>
                    
                </template>
            </Column> -->

            <Column field="Nombre" header="Nombre" :sortable="true" style="min-width: 3rem" :filter="true"
                :showFilterMenu="false">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                        placeholder="Buscar por nombre" />
                </template>
            </Column>


            <Column field="Razon_Social" :filter="true" header="Razon Social" style="min-width: 12rem">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                        placeholder="Buscar por Razon social" />
                </template>
            </Column>

            <Column field="RFC" header="RFC" :filter="true" :sortable="true" style="min-width: 3rem"
                :showFilterMenu="false">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                        placeholder="Buscar por RFC" />
                </template>
            </Column>

            <Column field="Email" header="Correo electronico" :filter="true" :sortable="true" style="min-width: 3rem"
                :showFilterMenu="false">
                <template #body="{ data }"> {{ data.Email }} </template>
            </Column>

            <Column field="tipo_cliente" header="Tipo de cliente" :filter="true" :sortable="true" style="min-width: 3rem"
                :showFilterMenu="false">
                <template #body="{ data }"> {{ data.Email }} </template>
            </Column>

        </DataTable>
    </div>
</template>

<script setup>
import MenuComponent from '@/components/MenuComponent.vue';
import api from '@/plugins/Axios';
import { Toast, useToast, Column, DataTable, Dialog, Button, InputText, FloatLabel, Select, MultiSelect } from 'primevue';
import { onMounted, ref } from 'vue';
import { FilterMatchMode } from '@primevue/core/api';

// const toast = useToast();
const prospectos = ref([]);
const toast = useToast();
const model = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
    RFC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Razon_Social: { value: null, matchMode: FilterMatchMode.CONTAINS },
});
const tipo = [
    { nombre: "Directo" },
    { nombre: "Logistica" },
    { nombre: "Agencia Aduanal" },
    { nombre: "Transportista" }
];

const empresas = ref([
    { nombre: "INTRA" },
    { nombre: "ICOLD" },
    { nombre: "EC" },
    { nombre: "TRANS" },
    { nombre: "VTS" }
])
const tipoCliente = ref("");
const modal = ref(false);
const empresa = ref("");
const rfc = ref("");
const correo = ref("");
const nombre_comercial = ref("");
const nombre_contacto = ref("");
const modal2 = ref(false);

const obtenerProspectos = async () => {
    try {
        let form = new FormData();
        form.append("getProspectos", "");
        const res = await api.post("/Api_Usuario", form);
        console.log(res.data)
        prospectos.value = res.data.result;
    }
    catch (err) {
        console.error(err);
        toast.add();
    }
}

const registrar = async () => {
    try {
        let form = new FormData();
        form.append("Razon_Social",nombre_comercial.value );
        form.append("Nombre_Completo", nombre_contacto.value);
        form.append("correo", correo.value);
        form.append("empresa", empresa.value.join());
        form.append("tipo_cliente", "");
        form.append("RFC", rfc.value);
        form.append("registrarProspecto", "");
        const res =  await api.post("/Api_Usuario", form);
        if(res.data.message ==="success")
        {
            ElimiarData();
            toast.add({ severity: 'success', summary: 'Completo', detail: "La organizacion se registro correctamente", life: 3000 });
            obtenerProspectos();
        }
        else
        {
            toast.add({ severity: 'error', summary: 'Error', detail: res.data.message, life: 3000 });
        }
    }
    catch (err) {
        console.error(err);
    }
}


const abrirRegistro = () => {
    modal.value = true;
}

const cerrarModal = () => {
    modal2.value = true;
}

const ElimiarData = ()=>{
    modal.value = false;
    modal2.value = false;
    tipoCliente.value = null;
    rfc.value = "";
    nombre_comercial.value = "";
    nombre_contacto.value = "";
    correo.value = "";
    empresa.value = null;
}

onMounted(() => {
    obtenerProspectos();
});
</script>

<style scoped>
.contenedor1 {
    width: 90%;
    margin: auto;
}


@media(max-width:1024px) {
    .contenedor1 {
        width: 100%;
        margin: auto;
    }

    .contenedor2 {
        width: 100%;
        margin: auto;
    }
}
</style>